import React from 'react';

import {TComponentRef, formField, newFormField} from '../FormField';
import {HiddenInput} from '../primitives';
import {TSize} from '../types';
import * as S from './style';

type TValue = any;

export type TProps = TComponentRef &
  Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> & {
    size?: TSize;
    checked?: TValue;
    value?: TValue;
    isInvalid?: boolean;
    indeterminate?: boolean;
  };

const Checkbox = React.memo<TProps>(
  ({
    className,
    name,
    size,
    onBlur,
    checked,
    onFocus,
    onChange,
    children,
    id: propId,
    disabled,
    readOnly,
    isInvalid,
    indeterminate,
  }) => {
    const id = propId || name;

    return (
      <S.Checkbox
        htmlFor={id}
        className={className}
        disabled={disabled}
        readOnly={readOnly}
        size={size}
      >
        <HiddenInput
          id={id}
          type="checkbox"
          name={name}
          checked={checked}
          disabled={disabled}
          readOnly={readOnly}
          onChange={disabled || readOnly ? undefined : onChange}
          onFocus={disabled ? undefined : onFocus}
          onBlur={disabled ? undefined : onBlur}
        />
        <S.ControlWrapper size={size}>
          <S.Control
            checked={checked}
            disabled={disabled}
            readOnly={readOnly}
            isInvalid={isInvalid}
            indeterminate={indeterminate}
          >
            {checked && <S.CheckedIcon />}
          </S.Control>
        </S.ControlWrapper>
        {children && <S.Label>{children}</S.Label>}
      </S.Checkbox>
    );
  },
);

export const NewCheckbox = React.memo<TProps>(
  ({
    className,
    name,
    size,
    onBlur,
    onFocus,
    onChange,
    children,
    id: propId,
    disabled,
    readOnly,
    isInvalid,
    indeterminate,
    value,
    innerRef,
  }) => {
    const id = propId || name;

    return (
      <S.Checkbox
        htmlFor={id}
        className={className}
        disabled={disabled}
        readOnly={readOnly}
        size={size}
      >
        <HiddenInput
          id={id}
          ref={innerRef}
          type="checkbox"
          name={name}
          checked={Boolean(value)}
          disabled={disabled}
          readOnly={readOnly}
          onChange={disabled || readOnly ? undefined : onChange}
          onFocus={disabled ? undefined : onFocus}
          onBlur={disabled ? undefined : onBlur}
        />
        <S.ControlWrapper size={size}>
          <S.Control
            checked={value}
            disabled={disabled}
            readOnly={readOnly}
            isInvalid={isInvalid}
            indeterminate={indeterminate}
          >
            {value && <S.CheckedIcon />}
          </S.Control>
        </S.ControlWrapper>
        {children && <S.Label>{children}</S.Label>}
      </S.Checkbox>
    );
  },
);

export default Checkbox;

export const CheckboxField = formField<TProps, boolean>(Checkbox, {
  showError: false,
});

export const NewCheckboxField = newFormField<TProps>(NewCheckbox, {
  showError: false,
});
